import React from 'react';
import { Shape } from '../../types/Shape';
import InlineTextEditor from '../InlineTextEditor';
import InlineMarkdownEditor from '../InlineMarkdownEditor';
import InlineCodeEditor from '../InlineCodeEditor';

export interface InlineEditorOverlayProps {
  // Editing state
  editingShape: string | null;
  editingText: string;
  editingPosition: { x: number; y: number; width: number; height: number } | null;
  editingMarkdown: string;
  editingMarkdownPosition: { x: number; y: number; width: number; height: number } | null;
  editingCode: string;
  editingCodeLanguage: string;
  editingCodePosition: { x: number; y: number; width: number; height: number } | null;

  // Context
  shapes: Shape[];
  stageScale: number;
  overlayZIndex: number;

  // Handlers
  setEditingText: React.Dispatch<React.SetStateAction<string>>;
  setEditingMarkdown: React.Dispatch<React.SetStateAction<string>>;
  setEditingCode: React.Dispatch<React.SetStateAction<string>>;
  setEditingCodeLanguage: React.Dispatch<React.SetStateAction<string>>;
  onComplete: () => void;
  onCancel: () => void;
}

export const InlineEditorOverlay: React.FC<InlineEditorOverlayProps> = ({
  editingShape,
  editingText,
  editingPosition,
  editingMarkdown,
  editingMarkdownPosition,
  editingCode,
  editingCodeLanguage,
  editingCodePosition,
  shapes,
  stageScale,
  overlayZIndex,
  setEditingText,
  setEditingMarkdown,
  setEditingCode,
  setEditingCodeLanguage,
  onComplete,
  onCancel,
}) => {
  const currentShape = editingShape ? shapes.find(s => s.id === editingShape) : null;

  return (
    <>
      <InlineTextEditor
        key={editingShape}
        isVisible={!!editingShape && editingPosition !== null}
        position={editingPosition}
        text={editingText}
        fontSize={(currentShape?.fontSize || 16) * stageScale}
        zIndex={overlayZIndex}
        onTextChange={setEditingText}
        onComplete={onComplete}
        onCancel={onCancel}
      />

      <InlineMarkdownEditor
        isVisible={!!editingShape && editingMarkdownPosition !== null && currentShape?.type === 'md'}
        position={editingMarkdownPosition}
        markdown={editingMarkdown}
        fontSize={(currentShape?.fontSize || 14) * stageScale}
        zIndex={overlayZIndex}
        onMarkdownChange={setEditingMarkdown}
        onComplete={onComplete}
        onCancel={onCancel}
      />

      <InlineCodeEditor
        isVisible={!!editingShape && editingCodePosition !== null && currentShape?.type === 'code'}
        position={editingCodePosition}
        code={editingCode}
        language={editingCodeLanguage}
        fontSize={(currentShape?.fontSize || 14) * stageScale}
        zIndex={overlayZIndex}
        backgroundColor={currentShape?.fill || '#FFFFFF'}
        onCodeChange={setEditingCode}
        onLanguageChange={setEditingCodeLanguage}
        onComplete={onComplete}
        onCancel={onCancel}
      />
    </>
  );
};

export default InlineEditorOverlay;
